import React, { useEffect, useState } from "react";
import CustomTable from "@components/CustomTable";
import myStore from "./store";
import { Observer } from "mobx-react";
import {
  getCutoffSettings,
  fetchDynamicFilters,
  transformData,
} from "@helpers/helpers";
import { useTranslation } from "react-i18next";

import {
  PINNING_INITIAL_STATE,
  TABLE_CONFIG,
} from "./constants";
import { buildColumns } from "./columns/columnsConfig";
import { buildFilters } from "./filters/filterConfig";
import { buildSelectedFiltersDisplay } from "./filters/filterDisplayConfig";
import { buildFilterDisplayValues } from "./filters/filterValuesConfig";
import { buildActions } from "./actions/actionsConfig";

const ReconciliationRunsComponent = () => {
  const { t: translate, i18n } = useTranslation();
  const [dynamicFilters, setDynamicFilters] = useState([]);
  const [cutOffSettings, setCutOffSettings] = useState({});

  useEffect(() => {
    fetchDynamicFilters("ReconciliationRunFilters", (newFilters) => {
      setDynamicFilters(newFilters);
    });
    getCutoffSettings((cutOffSettings) => {
      setCutOffSettings(cutOffSettings.CutoffSettings);
    });
  }, []);

  const getDynamicFilters = (key, onlyChildren = false) => {
    return transformData(
      (!!dynamicFilters &&
        !!dynamicFilters.length &&
        dynamicFilters.find((filter) => filter.ColumnName === key)?.Values) ||
        [],
      onlyChildren
    );
  };

  const columns = buildColumns(translate);
  const filters = buildFilters(getDynamicFilters, translate);
  const selectedFiltersDisplay = buildSelectedFiltersDisplay(translate);
  const filterDisplayValues = buildFilterDisplayValues(translate);
  const actions = buildActions(translate);

  return (
    <Observer>
      {() => {
        return (
          <>
            <CustomTable
              language={i18n.language}
              maxTableHeight={TABLE_CONFIG.maxHeight}
              store={myStore}
              columnsWithoutPin={columns}
              loading={myStore.loading}
              pinCondition={(row) => {
                return row.IsScheduled;
              }}
              filterDisplayValues={filterDisplayValues}
              selectedFiltersDisplay={selectedFiltersDisplay}
              filters={filters}
              pinningInitialState={PINNING_INITIAL_STATE}
              setParentSelectedValues={() => {}}
              actions={actions}
              prefix={TABLE_CONFIG.prefix}
              title={translate("reconciliation-runs.title")}
              pinnedRowHeight={TABLE_CONFIG.pinnedRowHeight}
              headerHeight={TABLE_CONFIG.headerHeight}
            />
          </>
        );
      }}
    </Observer>
  );
};

export default ReconciliationRunsComponent;
